// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StreakMultipleFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M82.5 72c0 5.514-4.486 10-10 10s-10-4.486-10-10 4.486-10 10-10 10 4.486 10 10m-69-48c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10-10-4.486-10-10m43.848 48.765c.026-.066.042-.135.062-.202.017-.057.039-.112.051-.171a2.028 2.028 0 0 0 0-.784c-.012-.059-.034-.114-.051-.171-.02-.067-.036-.136-.062-.202-.029-.067-.067-.128-.102-.192-.027-.05-.051-.103-.083-.152a1.992 1.992 0 0 0-.251-.307l-6.655-6.655a2 2 0 1 0-2.828 2.828L50.672 70H15.5a2 2 0 0 0 0 4h35.172l-3.243 3.243a1.998 1.998 0 0 0 1.414 3.414c.511 0 1.023-.195 1.414-.586l6.655-6.655c.094-.094.178-.197.251-.307.032-.049.056-.102.083-.152.035-.064.073-.125.102-.192M80.5 46h-65a2 2 0 0 0 0 4h65a2 2 0 0 0 0-4m-41-22a2 2 0 0 1 2-2h39a2 2 0 0 1 0 4h-39a2 2 0 0 1-2-2"
			fillRule="evenodd"
		/>
	</svg>
);
export default StreakMultipleFilled;
